import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import Slice9Panel from "../../../../../lib/html5-software-library/src/ranj/components/scale9/Slice9Panel";
import TextContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/TextContent";
import Anchor from "../../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AssetLibrary from "../../../core/assetloading/AssetLibrary";
import SoundType from "../../../core/sound/util/SoundType";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import DebugModel from "../../debug/model/DebugModel";
import DisplayObjectUtil from "../../util/DisplayObjectUtil";
import MovieClipUtil from "../../util/MovieClipUtil";
import ChapterIntroductionEvent from "../event/ChapterIntroductionEvent";

export default class ChapterIntroductionScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {AssetLibrary} assetLibrary
     * @param {SoundManager} soundManager
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, assetLibrary, soundManager) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._assetLibrary = assetLibrary;
        this._soundManager = soundManager;

        /** @type {TextContent} */
        this._content = this.getCustomData().content;
    }

    initialize() {
        super.initialize();

        this._initializeBackground();

        this._slice9Panel = new Slice9Panel(this._target.chapterPanel, MovieClipUtil.getFirstBitmapChild(this._target.chapterPanel), {
            mode: Slice9Panel.VERTICAL,
            pixelPerfect: true,
            overlap: false,
        });

        this._target.chapterPanel.narrativeTextField.text = this._content.getText()?.trim();
        this._slice9Panel.update();
        this._target.chapterPanel.y -= this._slice9Panel.getDeltaHeight();

        this._nextButton = this.createButton(this._target.nextButton, this._handleNextButton.bind(this), SoundType.BUTTON_CLICK);

        if (DebugModel.skipIntro) {
            setTimeout(() => this._finish(), 250);
            return;
        }
    }

    destroy() {
        super.destroy();
    }

    _handleNextButton() {
        this.disableInteraction();
        this._finish();
    }

    _finish() {
        const chapterIntroductionEvent = new ChapterIntroductionEvent(ChapterIntroductionEvent.FINISH);
        this.dispatch(chapterIntroductionEvent.type, { data: chapterIntroductionEvent });
    }

    _initializeBackground() {
        this._backgroundImageContainer = this._target.bgImageContainer;
        this._backgroundImageContainer.removeAllChildren();

        const backgroundImage = this._assetLibrary.getAsset(this._content.getBalloonType());
        const backgroundBitmap = new createjs.Bitmap(backgroundImage);
        DisplayObjectUtil.anchorDisplayObject(backgroundBitmap, Anchor.C);
        this._backgroundImageContainer.addChild(backgroundBitmap);
    }
}
